import React, { useState, useEffect } from "react";
import { ReactTitle } from "react-meta-tags";
import Modal from "../../../utils/customModal";
import * as instanceActions from "../../../../Redux/api";
import TableAdmissions from "../../../shared/admissions/table";
import {
  loadingHtml,
  errorContainer,
  sucessInfoModal,
} from "../../../utils/functions";
import noAproval from "../../../../../static/images/add-client-bsc.svg";
import * as ClientActions from "../../../../Redux/actions/clientActions";
import {
  getPendingClients,
  getTotalPendingClients,
} from "../../../../Redux/reducer/clients";
import CompanyTemporal from "../../../shared/customer/companyTemporal";
import ActionMenuList from "canvas-core-react/lib/ActionMenuList";
import IconShow from "canvas-core-react/lib/IconShow";
import ActionMenuListItem from "canvas-core-react/lib/ActionMenuListItem";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";

const getFilters = ({ name, id }) => {
  return [
    { name, property: "institution.companyName", operator: "eq" },
    {
      name: id,
      property: "institution.businessId",
      operator: "eq",
    },
    {
      name: "CIF",
      property: "institution.cif",
      operator: "eq",
    },
  ];
};

let _isMounted = false;

const nameRef = "general";

const ClientApprovalsComponent = ({ setFilters }) => {
  const [state, setState] = useState({
    page: 0,
    sizePerPage: 10,
    contentReady: false,
    modal: {
      show: false,
      content: null,
      onClose: undefined,
      showClose: false,
    },
    list: true,
    component: false,
    institution: {},
    menus: [],
  });

  const { pending, total } = useSelector((state) => ({
    pending: getPendingClients(state),
    total: getTotalPendingClients(state),
  }));

  const dispatch = useDispatch();
  const { t } = useTranslation();

  const { labels, states, headers, detailText, pageTitle, buttons, modalText } =
    {
      labels: t(`${nameRef}.labels`, { returnObjects: true }),
      states: t(`${nameRef}.states`, { returnObjects: true }),
      headers: t(`${nameRef}.headers`, { returnObjects: true }),
      detailText: t("detail"),
      pageTitle: t("admissions.tabs.clients"),
      buttons: t(`${nameRef}.buttons`, { returnObjects: true }),
      modalText: t(`${nameRef}.modal`, { returnObjects: true }),
      noDataMsg: t("admissions.noData", { returnObjects: true }),
    };

  const filters = getFilters(labels);

  useEffect(() => {
    _isMounted = true;
    setFilters({ filters, search: getSearchResult });
    getPendingData();

    return () => {
      _isMounted = false;
      setFilters({ filters: undefined, search: undefined });
      dispatch(ClientActions.clearPendingClients());
    };
  }, []);

  const getSearchResult = (property, value = "") => {
    const cleanValue = value.trim();
    let customFilters = [];

    if (cleanValue !== "") {
      // Realizamos la busqueda por filtros
      let operator = "";
      filters.map((item) => {
        if (item.property == property) {
          operator = item.operator;
        }
      });
      customFilters = [
        { property: property, operator: operator, value: cleanValue },
      ];
    }

    handlerTableChange({
      page: 0,
      sizePerPage: state.sizePerPage,
      customFilters,
    });
  };

  const getPendingData = async () => {
    await dispatch(ClientActions.getPendingClients());
    if (_isMounted) setState((prev) => ({ ...prev, contentReady: true }));
  };

  const getData = () => {
    const test = {
      TRANSITORY: { className: "pending-client", label: states.PENDING },
      DELETED: { className: "pending-client", label: states.DELETED },
      INACTIVE: { className: "inactive", label: states.INACTIVE },
      ACTIVE: { className: "success", label: states.ACTIVE },
      REJECTED: { className: "inactive", label: states.REJECTED },
    };

    const getStatus = (status) => {
      const { className, label } = test[status] || {
        className: "success",
        label: states[status],
      };
      return <span className={`StatusBadge__span ${className}`}>{label}</span>;
    };

    return pending?.map((item) => ({
      companyName: (
        <a
          className={"admission-p record"}
          onClick={() => getCompanyDetail(item)}
        >
          {item.companyName}
        </a>
      ),
      companyId: item.businessId,
      actionMaked:
        item.company.status !== "TRANSITORY"
          ? states.MODIFICATION
          : states.CREATION,
      updatedBy: item.company.updateBy,
      status: getStatus(item.company.status),
      id: item.company.id,
      cif: item.cif,
      item,
    }));
  };

  const handleMenu = (id, open) => {
    const { menus } = state;
    menus[`menu-${id}`] = open;
    setState({ ...state, menus });
  };

  const getTableColumns = () => {
    const { menus } = state;
    return [
      { grow: 2, selector: "cif", name: "CIF" },
      { grow: 2, selector: "companyName", name: headers.company },
      { grow: 2, selector: "companyId", name: headers.id },
      { grow: 2, selector: "actionMaked", name: headers.action },
      { grow: 2, selector: "updatedBy", name: headers.updatedBy },
      { grow: 2, selector: "status", name: headers.state, center: true },
      {
        grow: 2,
        selector: "actions",
        name: headers.actions,
        center: true,
        cellFormatter: (row) => (
          <ActionMenuList
            dialogPosition="bottom-right"
            iconType="horizontal-small"
            bottomSheet={{
              heading: "Actions",
              secondaryAction: {
                onClick: () => {},
                label: "Cancel",
              },
            }}
            isMenuOpen={menus[`menu-${row.item.id}`] || false}
            setIsMenuOpen={(open) => handleMenu(row.item.id, open)}
          >
            <ActionMenuListItem
              icon={() => (
                <IconShow
                  id={`client-approval-${row.item.id}`}
                  className="TextButton__icon--left"
                />
              )}
              onClick={() => loadCompanyTemp(row.item)}
            >
              {detailText}
            </ActionMenuListItem>
          </ActionMenuList>
        ),
      },
    ];
  };

  const loadCompanyTemp = (item) => {
    const { menus } = state;
    menus[`menu-${item.id}`] = false;
    setState((prev) => ({ ...prev, menus }));
    getCompanyDetail(item);
  };

  const getCompanyDetail = async ({ company }) => {
    const { modal } = state;

    modal.content = loadingHtml();
    modal.show = true;

    setState({ ...state, modal });
    const response = await dispatch(
      ClientActions.getInstitutionProfile(company.id)
    );

    closeModal();
    setState((prevState) => ({
      ...prevState,
      list: false,
      component: true,
      institution: response.data,
      menus: [],
    }));
  };

  const finishAdmission = () => {
    const buttonsModal = {
      SelBtn: {
        text: buttons.continue,
        action: closeModal,
      },
    };

    const content = sucessInfoModal(pageTitle, modalText.success, buttonsModal);

    setState((prevState) => ({
      ...prevState,
      modal: { content, show: true, showClose: true, onClose: closeModal },
    }));
  };

  const commitActions = async (approve, elements) => {
    const { modal } = state;

    modal.content = loadingHtml();
    modal.show = true;

    setState({ ...state, modal });
    let updateStates = [];

    Object.keys(elements).map((key) => {
      let idClient = key.split("-")[1];
      updateStates.push({
        id: idClient,
        approve,
      });
      return true;
    });

    try {
      const response = await dispatch(
        instanceActions.instanceAction(
          "/companies/approve-or-rejected",
          "put",
          updateStates
        )
      );
      if (response.data?.data[0]?.success === false) {
        modal.show = true;
        modal.content = errorContainer(
          modalText.error,
          response.data?.data[0]?.message,
          {
            continueBtn: {
              text: buttons.continue,
              action: closeModal,
            },
          }
        );
      } else if (response.data.notifications === null) finishAdmission();

      setState((prev) => ({ ...prev, contentReady: false }));
      getPendingData();
    } catch (err) {
      if (
        err.response !== undefined &&
        Array.isArray(err.response.data.notifications)
      ) {
        const notification = err.response.data?.notifications[0];
        modal.content = errorContainer(
          notification.message,
          notification.description,
          { cancelBtn: { text: buttons.close, action: () => closeModal() } }
        );
      }
      modal.onClose = () => closeModal();

      setState((prev) => ({ ...prev, contentReady: false, modal }));
      getPendingData();
    }
  };

  const handlerTableChange = async ({
    page,
    sizePerPage,
    customFilters = [],
  }) => {
    await dispatch(
      ClientActions.getPendingClients(page, sizePerPage, customFilters)
    );
    setState((prev) => ({ ...prev, page, sizePerPage }));
  };

  const closeModal = () => {
    setState((prev) => ({
      ...prev,
      modal: {
        show: false,
        content: null,
        onClose: undefined,
        showClose: false,
      },
    }));
  };

  const closeInfo = (refress) => {
    setState((prev) => ({
      ...prev,
      list: true,
      component: false,
      institution: {},
    }));
    if (refress) getPendingData();
  };

  const { contentReady, sizePerPage, page, modal, list, component } = state;

  const data = getData();

  return (
    <>
      <ReactTitle title={`${pageTitle} - Reverse Factoring`} />
      {contentReady ? (
        pending.length > 0 ? (
          list && (
            <TableAdmissions
              headers={getTableColumns()}
              data={data}
              page={page}
              addmissionType={`client`}
              sizePerPage={sizePerPage}
              totalSize={total}
              onTableChange={handlerTableChange}
              submitAdmissions={commitActions}
            />
          )
        ) : (
          <div id="blankAprrovals">
            <img src={noAproval} className="clientImage" />
            <p>{t("admissions.noUserAdmissions")}.</p>
            <div className="line-aproval"></div>
          </div>
        )
      ) : (
        <div className="loader innner"></div>
      )}
      {component && (
        <CompanyTemporal
          closeInfo={closeInfo}
          institution={state.institution}
        />
      )}
      <Modal
        show={modal.show}
        handleClose={modal.onClose}
        showClose={modal.showClose}
      >
        {modal.content}
      </Modal>
    </>
  );
};

export default ClientApprovalsComponent;
